import { render, staticRenderFns } from "./ShareSetting.vue?vue&type=template&id=7c470980&scoped=true&"
import script from "./ShareSetting.vue?vue&type=script&lang=js&"
export * from "./ShareSetting.vue?vue&type=script&lang=js&"
import style0 from "./ShareSetting.vue?vue&type=style&index=0&id=7c470980&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c470980",
  null
  
)

export default component.exports